#import "../../common/graphql/EntityDocumentsFields.graphql"
#import "../../common/graphql/ApprovalHistorySignaturesFields.graphql"
#import "../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

fragment PurchaseOrderListFields on PurchaseOrder {
      __typename
    id
    purchaseOrderNumber
     _urgencyLevel
    documentFileId
    _purchaseOrderDeliveryId
    supplierId
    _isRevisable
    sortSupplierName
    supplier {
      id
      _isApproved
      _fullName
      _isAliasOriginalNameViewable
      _isAliasInvoked
      _isUpdatable
      supplierAddressesBySupplierId(orderBy: IS_PRIMARY_DESC, first: 1) {
        nodes {
          isPrimary
          addressLine1
          addressLine2
          cityName
          postalCode
          stateRegion {
            stateRegion
            country {
              country
            }
            stateRegionDescription
          }
          telephoneNumber
          emailAddress
        }
      }
      vendorNumber
      vendorServiceRate
    }
    purchaseOrderTypeId
    purchaseOrderDate
    currencyId
    currency {
      id
      isoCode
      currencySymbol
    }

    _isDistributionUpdateAllowed
    _subjectToDiscount
    _subjectToTax
    departmentId
    businessUnitId
    businessUnit {
      _isProductionBusinessUnit
      id
      name
      companyAddress {
        addressAlias
        addressLine1
        addressLine2
        cityName
        postalCode
      }
    }
    _isInvoiceScheduleViewable
    entityDocumentId
    _isAccountingEntry
    _isHistory
    _isStampAllowed
    _isUnstampAllowed
    _isRevisable
    _isTransactionCancelled
    _isAccountingEntryStampedComplete
    _accountingStampDate
    _accountingStampUserName
    _accountingStampTransactionReference
    _isInvoiceScheduleViewable
    _isInvoiceScheduleUpdatable
    stampedEntityDocumentId
    entityDocumentId
    purchaseOrderRevisionHistoriesByPoGroupId(
      orderBy: DATE_REQUESTED_DESC
      filter: { id: { notEqualTo: $id } }
    ) {
      nodes {
        supplierReferenceName
        id
        purchaseOrderNumber
        description
        poTotal
        dateRequested
        requesterName
      }
    }
    reason
    description
    controlTotalAmount
    _baseCurrencyAmount
    _spotCurrencyAmount
    _isUpdatable
    _isDeletable
    deliveryAddressId
    deliveryAddressAlias
    deliveryAddressLine1
    deliveryAddressLine2
    deliveryCityName
    deliveryCountryId
    deliveryStateRegionId
    deliveryPostalCode
    deliveryTelephoneNumber
    deliveryEmailAddress
    scheduledDeliveryDate
    deliveryNotes
    isDeliveryTracked
    
    isDraft
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    purchaseOrderItems(orderBy: _SORT_ITEM_NUMBER_ASC) {
      nodes {
        id
        _rowTimestamp
        __typename
        purchaseOrderItemTypeId
        purchaseOrderItemType {
          calculationType
          layoutType
          abbreviation
          description
          id
        }
        itemNumber
        _isUpdatable
        _isDeletable
        itemExtendedAmount
        displayPoItemAccount
        displayPoItemQuantity
        displayPoItemUnitPrice
        displayPoItemTotal
        displayPoItemDescription
        displayPoItemRentalTerm
        displayPoItemType
        description
        isTaxable
        isDiscounted
        _extendedItemTotal
        itemQuantity
        itemRentalDates
        itemUnitPrice
        itemFromDate
        purchaseOrderItemType {
          layoutType
          abbreviation
        }
        _isActive
      }
    }
    _rowTimestamp
    purchaseOrderHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
      totalCount
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _createdDate
        createdByUser
        _rowTimestamp
      }
    }
    entityEnvironmentalsByEntityId {
      nodes {
        environmentalMetric {
          environmentalMetric
          layoutType
        }
        description
        endDate
        startDate
        _rowTimestamp
        _createdDate
        id
        _isDeletable
        _isUpdatable
        environmentalMetricId
        entityEnvironmentalItems(
          orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__SORT_ORDER_ASC
        ) {
          nodes {
            carbonCreditsAmount
            entityEnvironmentalId
            environmentalImpactTypeId
            _isIntegerFormat
            _isFloatFormat
            _isAmountFormat
            feet
            gallons
            hours
            id
            kilogram
            kilometers
            kilowattHours
            litres
            meters
            metricTonnes
            miles
            omissionsEquivalent
            pounds
            quantity
            therms
            tons
            yards
            _rowTimestamp
            _isUpdatable
            _isDeletable
          }
        }
      }
    }
    _isEnvironmentalsExist
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    _isPromoteAddressAllowed
    _isStagedApprovalRequest
    _isApprovalRevocable
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        ...ApprovalHistorySignaturesFields
      }
    }
    _emailDocument {
      ...EmailDocumentFields
    }
    emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
